import { m } from "framer-motion";
import type { Variants } from "framer-motion";
import { fadeIn } from "./config/animationConfig";

const drawClockwiseFrom8: Variants = {
    hidden: { pathLength: 0, pathOffset: 0.42, opacity: 0 },
    visible: {
        pathLength: 1,
        pathOffset: -0.58,
        opacity: 1,
        transition: {
            pathLength: { duration: 2, ease: "easeInOut", delay: 0.15 },
            pathOffset: { duration: 2, ease: "easeInOut", delay: 0.15 },
            opacity: { duration: 0.3, delay: 0.15 },
        },
    },
};

const desktopSvgClassName = "w-[700px] 2xl:w-[962px] absolute bottom-0 right-0 translate-x-[0%] translate-y-[20%] z-[1] hidden lg:block";
const mobileSvgClassName = "w-[673px] absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 z-[1] lg:hidden";

const circleProps = {
    cx: "580.567",
    cy: "580.567",
    r: "579.567",
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 793.166 1373.73)",
    strokeWidth: "2",
} as const;

const MissionCircle = () => {
    return (
        <>
            <m.svg
                className={desktopSvgClassName}
                viewBox="0 0 721 572"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
            >
                <m.circle
                    {...circleProps}
                    stroke="url(#mission_gradient_desktop)"
                    variants={drawClockwiseFrom8}
                />
                <defs>
                    <linearGradient id="mission_gradient_desktop" x1="1161.81" y1="-168.035" x2="-181.196" y2="1175.52" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" stopOpacity="0" />
                        <stop offset="1" stopColor="#6A7282" />
                    </linearGradient>
                </defs>
            </m.svg>

            <m.svg
                className={mobileSvgClassName}
                viewBox="0 0 674 674"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={fadeIn}
            >
                <circle
                    cx="336.903"
                    cy="336.903"
                    r="336.323"
                    transform="matrix(-0.965926 0.258819 0.258819 0.965926 575.213 -75.6328)"
                    stroke="url(#mission_gradient_mobile_0)"
                    strokeWidth="1.1606"
                />
                <circle
                    cx="336.903"
                    cy="336.903"
                    r="336.323"
                    transform="matrix(-0.965926 0.258819 0.258819 0.965926 575.213 -75.6328)"
                    stroke="url(#mission_gradient_mobile_1)"
                    strokeWidth="1.1606"
                />
                <defs>
                    <linearGradient id="mission_gradient_mobile_0" x1="405.265" y1="45.0675" x2="-84.5318" y2="353.25" gradientUnits="userSpaceOnUse">
                        <stop stopColor="white" />
                        <stop offset="1" stopColor="white" stopOpacity="0" />
                    </linearGradient>
                    <linearGradient id="mission_gradient_mobile_1" x1="674.198" y1="-97.5104" x2="-105.148" y2="682.151" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#6A7282" />
                        <stop offset="1" stopColor="white" stopOpacity="0" />
                    </linearGradient>
                </defs>
            </m.svg>
        </>
    );
};

export default MissionCircle;
